<template>
    <div>
        <RouterView />
    </div>
</template>

<script setup lang="ts"></script>
<style lang="scss">
html {
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    height: 100%;
    min-height: 100%;
}
body {
    font-family: HeinemannSpecial-Roman, Arial, sans-serif;
    background: #edf6f9;
    background-position: 50% 50%;
    background-size: cover;
    background-attachment: fixed;
}
#content {
    padding: 30px 0 60px 0;
}
.wrap {
    max-width: 978px;
    margin: 0 auto;
}
</style>
